module.exports = __webpack_public_path__ + "static/media/canari_birthday.f7e40fb3.png";